/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerSubmitExplainMutationResponse } from "../../models/aiAgentV2Controller/AiAgentV2ControllerSubmitExplain";

function getAiAgentV2ControllerSubmitExplainUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/explain` as const }  
  return res
}

/**
 * @description Explain selected text without loading full document context
 * @summary Submit a text explanation request
 * {@link /api/v1/ai-agent-v2/explain}
 */
export async function aiAgentV2ControllerSubmitExplain(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerSubmitExplainMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAiAgentV2ControllerSubmitExplainUrl().url.toString(), ... requestConfig })  
  return res.data
}